(function () {
  const ROOT_SELECTOR = '[data-pdp-root]';
  const MOBILE_QUERY = '(max-width: 989px)';
  const DESKTOP_QUERY = '(min-width: 990px)';
  const NAV_REVEAL_SCROLL_DELTA = 10;
  const NAV_REVEAL_MIN_SCROLL = 24;

  function normalizeText(value) {
    return (value || '')
      .toString()
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function onMediaQueryChange(mql, handler) {
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler);
      return;
    }

    if (typeof mql.addListener === 'function') {
      mql.addListener(handler);
    }
  }

  function isDirectionsHeading(value) {
    const normalized = normalizeText(value);
    return normalized === 'directions' || normalized === 'طريقة الاستخدام';
  }

  function isDetailAccordion(element) {
    return element.classList.contains('product__accordion') || element.classList.contains('accordion');
  }

  function isSupportNode(element) {
    return (
      element.matches('share-button') ||
      element.matches('product-recommendations') ||
      element.classList.contains('product-popup-modal__opener') ||
      element.classList.contains('product-popup-modal__button') ||
      element.classList.contains('icon-with-text')
    );
  }

  function isBundleSupportNode(element) {
    const id = element?.id || '';
    return id === 'dg-bundle-note' || id === 'dg-bundle-support-note';
  }

  function buildRichTextNode(html) {
    const wrapper = document.createElement('div');
    wrapper.className = 'product__panel-copy rte';
    wrapper.innerHTML = html;
    return wrapper;
  }

  function buildPanelSection(heading, html) {
    const section = document.createElement('section');
    section.className = `product__panel-section product__panel-section--${normalizeText(heading)
      .replace(/[^a-z0-9\u0600-\u06ff]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'details'}`;

    const title = document.createElement('h3');
    title.className = 'product__panel-heading';
    title.textContent = heading;

    const copy = document.createElement('div');
    copy.className = 'product__panel-copy rte';
    copy.innerHTML = html;

    section.append(title, copy);
    return section;
  }

  function slugifyValue(value) {
    return normalizeText(value)
      .replace(/[^a-z0-9\u0600-\u06ff]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getFloatingRewardsLaunchers() {
    const selectors = [
      '#appstle_subscription_widget',
      '#appstle_loyalty_points_float',
      '#appstle_widget',
      '[id*="appstle"]',
      '[class*="appstle"]',
      '[id*="reward"]',
      '[class*="reward"]',
      '[id*="loyal"]',
      '[class*="loyal"]',
    ];

    return Array.from(document.querySelectorAll(selectors.join(','))).filter((element) => {
      if (!element || element.closest('[data-pdp-sticky-bar]')) return false;

      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (style.position !== 'fixed' && style.position !== 'sticky') return false;

      const rect = element.getBoundingClientRect();
      if (rect.width < 40 || rect.height < 30) return false;

      const nearBottom = rect.bottom >= window.innerHeight - 120;
      const nearEdge = rect.left <= 120 || rect.right >= window.innerWidth - 120;

      return nearBottom && nearEdge;
    });
  }

  function getDisplayedPriceText(root) {
    const priceRoot = root.querySelector('[id^="price-"]');
    if (!priceRoot || priceRoot.classList.contains('hidden')) return '';

    const node =
      priceRoot.querySelector('.price__sale .price-item--sale') ||
      priceRoot.querySelector('.price__regular .price-item--regular');

    if (!node) return '';

    const clone = node.cloneNode(true);
    clone
      .querySelectorAll('.price-tax-label, .badge, .price-currency-accessible')
      .forEach((element) => element.remove());
    return clone.innerHTML.trim();
  }

  function copyNodeWithoutIds(node) {
    const clone = node.cloneNode(true);
    if (clone.removeAttribute) clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    return clone;
  }

  function getBottomFixedOffset(stickyBar) {
    let offset = 0;

    document.querySelectorAll('body *').forEach((element) => {
      if (element === stickyBar || stickyBar.contains(element)) return;

      const style = window.getComputedStyle(element);
      if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden') return;

      const rect = element.getBoundingClientRect();
      if (rect.height < 40 || rect.width < window.innerWidth * 0.45) return;
      if (Math.abs(window.innerHeight - rect.bottom) > 4) return;
      if (rect.top < window.innerHeight * 0.45) return;

      offset = Math.max(offset, rect.height);
    });

    return offset;
  }

  function setupGalleryProgress(root) {
    const viewer = root.querySelector('[id^="GalleryViewer-"]');
    const progress = root.querySelector('[data-gallery-progress]');
    if (!viewer || !progress) return;

    const update = () => {
      const current = parseInt(root.querySelector('.slider-counter--current')?.textContent || '1', 10);
      const total = parseInt(root.querySelector('.slider-counter--total')?.textContent || '1', 10);
      const percentage = total > 0 ? (current / total) * 100 : 100;
      progress.style.setProperty('--gallery-progress', `${Math.max(percentage, 8)}%`);
    };

    viewer.addEventListener('slideChanged', update);
    window.addEventListener('resize', update, { passive: true });
    window.requestAnimationFrame(update);
  }

  function bindSupportTrigger(stickyBar) {
    const trigger = stickyBar.querySelector('[data-pdp-support-trigger]');
    if (!trigger || trigger.dataset.bound === 'true') return;

    trigger.dataset.bound = 'true';
    trigger.addEventListener('click', () => {
      const chatButton = document.getElementById('diggn-chat-button');
      if (chatButton) {
        chatButton.click();
      }
    });
  }

  function syncStickyBar(root, stickyBar) {
    const stickyButton = stickyBar.querySelector('[data-pdp-sticky-submit]');
    const stickyText = stickyBar.querySelector('[data-pdp-sticky-text]');
    const stickyPrice = stickyBar.querySelector('[data-pdp-sticky-price]');
    const utilityNav = stickyBar.querySelector('[data-pdp-utility-nav]');
    const section = root.closest('section');
    const mobileMedia = window.matchMedia(MOBILE_QUERY);
    const purchaseAnchor =
      root.querySelector('.product-form__buttons') ||
      root.querySelector('[id^="ProductSubmitButton-"]') ||
      root.querySelector('[id^="ProductInfo-"]');
    const chatButton = document.getElementById('diggn-chat-button');

    let lastScrollY = window.scrollY;

    const setUtilityNavVisibility = (shouldShow) => {
      if (!utilityNav) return;
      stickyBar.classList.toggle('is-utility-visible', shouldShow);
      stickyBar.classList.toggle('is-nav-visible', shouldShow);
      updateBottomOffset();
    };

    const syncFloatingSupportButton = () => {
      const shouldHide =
        mobileMedia.matches &&
        (stickyBar.classList.contains('is-visible') || stickyBar.classList.contains('is-utility-visible'));
      if (chatButton) {
        chatButton.classList.toggle('pdp-hidden-on-mobile', shouldHide);
      }
    };

    const update = () => {
      const mainButton = root.querySelector('[id^="ProductSubmitButton-"]');
      const mainText = mainButton?.querySelector('span');

      if (mainButton) {
        stickyButton.disabled = mainButton.disabled;
        stickyText.textContent = (mainText?.textContent || '').replace(/\s+/g, ' ').trim();
      }

      stickyPrice.innerHTML = getDisplayedPriceText(root);
    };

    const updateBottomOffset = () => {
      const offset = mobileMedia.matches ? getBottomFixedOffset(stickyBar) : 0;
      section?.style.setProperty('--pdp-mobile-nav-offset', `${offset}px`);
      section?.style.setProperty('--pdp-mobile-sticky-height', `${stickyBar.offsetHeight || 0}px`);
    };

    const buttonObserver = new MutationObserver(update);
    const priceObserver = new MutationObserver(update);
    const mainButton = root.querySelector('[id^="ProductSubmitButton-"]');
    const priceRoot = root.querySelector('[id^="price-"]');

    if (mainButton) {
      buttonObserver.observe(mainButton, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if (priceRoot) {
      priceObserver.observe(priceRoot, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const isVisible = entries[0]?.isIntersecting;
        const shouldShowStickyBar = mobileMedia.matches && !isVisible;
        stickyBar.classList.toggle('is-visible', shouldShowStickyBar);

        syncFloatingSupportButton();
        updateBottomOffset();
      },
      { threshold: 0.35 }
    );

    if (purchaseAnchor) {
      observer.observe(purchaseAnchor);
    }

    const onScroll = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;

      syncFloatingSupportButton();

      if (!mobileMedia.matches) {
        setUtilityNavVisibility(false);
        lastScrollY = currentScrollY;
        return;
      }

      if (currentScrollY < NAV_REVEAL_MIN_SCROLL) {
        setUtilityNavVisibility(false);
        lastScrollY = currentScrollY;
        return;
      }

      if (Math.abs(delta) < NAV_REVEAL_SCROLL_DELTA) return;

      setUtilityNavVisibility(delta < 0);
      lastScrollY = currentScrollY;
    };

    const onResize = () => {
      if (!mobileMedia.matches) {
        stickyBar.classList.remove('is-visible');
        setUtilityNavVisibility(false);
      }

      syncFloatingSupportButton();
      updateBottomOffset();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
    onMediaQueryChange(mobileMedia, onResize);

    bindSupportTrigger(stickyBar);
    update();
    syncFloatingSupportButton();
    updateBottomOffset();
  }

  function setupDesktopStickyState(root) {
    const desktopMedia = window.matchMedia(DESKTOP_QUERY);
    const stickyInfo = root.querySelector('.product__info-container.product__column-sticky');
    if (!stickyInfo) return;

    const update = () => {
      if (!desktopMedia.matches) {
        stickyInfo.classList.remove('product__column-sticky--overflow');
        return;
      }

      const availableHeight = Math.max(window.innerHeight - 48, 0);
      const isOverflowing = stickyInfo.offsetHeight > availableHeight;
      stickyInfo.classList.toggle('product__column-sticky--overflow', isOverflowing);
    };

    stickyInfo.querySelectorAll('details').forEach((element) => {
      element.addEventListener('toggle', () => window.requestAnimationFrame(update));
    });

    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('orientationchange', update, { passive: true });
    onMediaQueryChange(desktopMedia, update);
    window.requestAnimationFrame(update);
  }

  function setupDesktopThumbnailRail(root) {
    const desktopMedia = window.matchMedia(DESKTOP_QUERY);
    const mediaGallery = root.querySelector('media-gallery');
    const viewer = root.querySelector('.product__gallery-viewer');
    if (!mediaGallery || !viewer || mediaGallery.dataset.pdpThumbnailRailBound === 'true') return;

    mediaGallery.dataset.pdpThumbnailRailBound = 'true';

    const getViewerHeight = () => {
      const activeItem =
        viewer.querySelector('.product__media-item.is-active') || viewer.querySelector('.product__media-item');
      if (!activeItem) return 0;

      const activeMedia =
        activeItem.querySelector('.product-media-container') ||
        activeItem.querySelector('.product__modal-opener') ||
        activeItem.querySelector('.deferred-media') ||
        activeItem;

      return Math.round(activeMedia.getBoundingClientRect().height);
    };

    const update = () => {
      if (!desktopMedia.matches) {
        mediaGallery.style.removeProperty('--pdp-gallery-viewer-height');
        return;
      }

      const viewerHeight = getViewerHeight();
      if (viewerHeight > 0) {
        mediaGallery.style.setProperty('--pdp-gallery-viewer-height', `${viewerHeight}px`);
      }
    };

    const updateOnNextFrame = () => window.requestAnimationFrame(update);

    if (typeof ResizeObserver === 'function') {
      const observer = new ResizeObserver(updateOnNextFrame);
      observer.observe(viewer);
      viewer.querySelectorAll('.product__media-item').forEach((item) => observer.observe(item));
    }

    viewer.addEventListener('slideChanged', updateOnNextFrame);
    viewer.addEventListener('load', updateOnNextFrame, true);
    window.addEventListener('load', updateOnNextFrame, { once: true });
    window.addEventListener('resize', updateOnNextFrame, { passive: true });
    window.addEventListener('orientationchange', updateOnNextFrame, { passive: true });
    onMediaQueryChange(desktopMedia, updateOnNextFrame);
    updateOnNextFrame();
  }

  function setupDesktopGalleryWheel(root) {
    const desktopMedia = window.matchMedia(DESKTOP_QUERY);
    const viewer = root.querySelector('.product__gallery-viewer');
    if (!viewer || viewer.dataset.pdpWheelBound === 'true') return;

    viewer.dataset.pdpWheelBound = 'true';
    viewer.addEventListener(
      'wheel',
      (event) => {
        if (!desktopMedia.matches) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        event.preventDefault();
        window.scrollBy({
          top: event.deltaY,
          left: 0,
          behavior: 'auto',
        });
      },
      { passive: false }
    );
  }

  function syncMobileImageInteractivity(root) {
    const mobileMedia = window.matchMedia(MOBILE_QUERY);
    const buttons = root.querySelectorAll('.product__media-item .product__modal-opener--image .product__media-toggle');
    const images = root.querySelectorAll('.product__media-item .product__modal-opener--image img');
    if (!buttons.length) return;

    const update = () => {
      buttons.forEach((button) => {
        button.disabled = true;
        button.tabIndex = -1;
        button.setAttribute('aria-hidden', 'true');
        button.removeAttribute('aria-haspopup');
      });

      images.forEach((image) => {
        image.onclick = null;
        image.classList.remove('image-magnify-hover', 'image-magnify-full-size');
        image.style.cursor = mobileMedia.matches ? 'grab' : 'default';
      });
    };

    onMediaQueryChange(mobileMedia, update);
    update();
  }

  function suppressInjectedPromoPricing(root) {
    const infoScope = root.querySelector('.product__info-wrapper') || root;
    if (!infoScope || infoScope.dataset.pdpPromoPricingSuppressed === 'true') return;

    const sellySelectors = [
      '[class*="selly"]',
      '[id*="selly"]',
      '[class*="promotion-pricing"]',
      '[id*="promotion-pricing"]',
    ];
    const textMarkers = ['your price', 'السعر الخاص', 'سعرك الخاص'];
    const protectedSelectors = [
      '[id^="ProductInfo-"]',
      '.product__info-container',
      '.product-form',
      '.product-form__buttons',
      '.product-form__input',
      'variant-radios',
      'variant-selects',
      '.product__title',
      '.product__price-stack',
      '[id^="price-"]',
      '.price',
    ].join(',');

    const findRemovalTarget = (element) => {
      const explicitTarget = element.closest(sellySelectors.join(','));
      if (explicitTarget && infoScope.contains(explicitTarget)) return explicitTarget;

      let current = element instanceof HTMLElement ? element : null;
      for (let depth = 0; current && depth < 3; depth += 1) {
        if (current.matches?.(protectedSelectors)) return null;
        if (current.querySelector?.(protectedSelectors)) return null;

        const currentText = normalizeText(current.textContent);
        if (textMarkers.some((marker) => currentText.includes(marker)) && currentText.length <= 160) {
          return current;
        }

        current = current.parentElement;
      }

      return null;
    };

    const shouldRemove = (element) => {
      if (!(element instanceof HTMLElement)) return false;
      if (element.closest('[data-pdp-sticky-bar]')) return false;
      if (!infoScope.contains(element)) return false;
      if (element.matches(ROOT_SELECTOR) || element.closest('.product__detail-stack, .product__mobile-detail-stack')) {
        return false;
      }
      if (element.matches(protectedSelectors) || element.closest(protectedSelectors)) return false;

      const text = normalizeText(element.textContent);
      if (!text) return false;
      if (text.length > 120) return false;

      return textMarkers.some((marker) => text.includes(marker));
    };

    const prune = () => {
      infoScope.querySelectorAll('div, section, aside, p, span').forEach((element) => {
        if (!shouldRemove(element)) return;
        const target = findRemovalTarget(element);
        if (target && target !== root && !target.contains(root)) {
          target.hidden = true;
          target.style.setProperty('display', 'none', 'important');
        }
      });
    };

    const observer = new MutationObserver(() => prune());
    observer.observe(infoScope, { childList: true, subtree: true });
    prune();
    infoScope.dataset.pdpPromoPricingSuppressed = 'true';
  }

  function buildMobilePanels(root, mobileStack, desktopStack) {
    const labels = root.parentElement.querySelector('[data-pdp-labels]');
    const panels = [];
    const descriptionPanel = document.createElement('div');

    desktopStack.querySelectorAll('.product__description').forEach((element) => {
      descriptionPanel.appendChild(buildRichTextNode(element.innerHTML));
    });

    if (descriptionPanel.childNodes.length) {
      panels.push({
        id: 'description',
        label: labels?.dataset.descriptionLabel || 'Description',
        content: descriptionPanel,
      });
    }

    const accordionPanels = [];
    desktopStack.querySelectorAll('.product__accordion, .product__accordion--fragrances').forEach((element, index) => {
      const heading = element.querySelector('.accordion__title')?.textContent?.trim();
      const content = element.querySelector('.accordion__content');
      if (!heading || !content) return;

      const panelWrapper = document.createElement('div');
      panelWrapper.appendChild(buildPanelSection(heading, content.innerHTML));

      accordionPanels.push({
        id: `${slugifyValue(heading) || 'details'}-${index + 1}`,
        label: heading,
        content: panelWrapper,
      });
    });

    accordionPanels.forEach((panel) => panels.push(panel));

    const brandSource = root.parentElement.querySelector('[data-pdp-brand-source]');
    const brandContent = brandSource?.firstElementChild ? copyNodeWithoutIds(brandSource.firstElementChild) : null;
    if (brandContent) {
      desktopStack.appendChild(copyNodeWithoutIds(brandSource.firstElementChild));

      const aboutWrapper = document.createElement('div');
      aboutWrapper.appendChild(brandContent);
      panels.push({
        id: 'about',
        label: labels?.dataset.aboutLabel || 'About the brand',
        content: aboutWrapper,
      });
    }

    if (!panels.length) return;

    const nav = document.createElement('div');
    nav.className = 'product__mobile-detail-nav';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', labels?.dataset.detailsNavLabel || 'Product details');

    const panelsWrap = document.createElement('div');
    panelsWrap.className = 'product__mobile-detail-panels';

    const centerTabInNav = (button) => {
      if (!button) return;

      const navRect = nav.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();
      const offset = buttonRect.left - navRect.left - (navRect.width - buttonRect.width) / 2;

      if (Math.abs(offset) < 1) return;

      nav.scrollBy({
        left: offset,
        behavior: 'smooth',
      });
    };

    const activatePanel = (panelId, { shouldScrollNav = false } = {}) => {
      nav.querySelectorAll('[data-pdp-tab]').forEach((navButton) => {
        const matches = navButton.dataset.pdpTab === panelId;
        navButton.classList.toggle('is-active', matches);
        navButton.setAttribute('aria-selected', String(matches));
        navButton.setAttribute('tabindex', matches ? '0' : '-1');
      });

      panelsWrap.querySelectorAll('[data-pdp-panel]').forEach((panelElement) => {
        const matches = panelElement.dataset.pdpPanel === panelId;
        panelElement.classList.toggle('is-active', matches);
        panelElement.hidden = !matches;
        panelElement.setAttribute('aria-hidden', String(!matches));
      });

      const activeButton = nav.querySelector(`[data-pdp-tab="${panelId}"]`);
      if (
        shouldScrollNav &&
        window.matchMedia(MOBILE_QUERY).matches &&
        activeButton &&
        typeof nav.scrollBy === 'function'
      ) {
        centerTabInNav(activeButton);
      }
    };

    panels.forEach((panel, index) => {
      const isActive = index === 0;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `product__mobile-detail-pill${isActive ? ' is-active' : ''}`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', String(isActive));
      button.setAttribute('aria-controls', `ProductPanel-${root.dataset.sectionId}-${panel.id}`);
      button.setAttribute('tabindex', isActive ? '0' : '-1');
      button.dataset.pdpTab = panel.id;
      button.textContent = panel.label;

      const section = document.createElement('section');
      section.id = `ProductPanel-${root.dataset.sectionId}-${panel.id}`;
      section.className = `product__mobile-detail-panel${isActive ? ' is-active' : ''}`;
      section.setAttribute('role', 'tabpanel');
      section.setAttribute('aria-hidden', String(!isActive));
      section.dataset.pdpPanel = panel.id;
      section.hidden = !isActive;
      section.appendChild(panel.content);

      button.addEventListener('click', () => activatePanel(panel.id, { shouldScrollNav: true }));

      nav.appendChild(button);
      panelsWrap.appendChild(section);
    });

    mobileStack.append(nav, panelsWrap);
    activatePanel(panels[0].id);
  }

  function buildDetailLayout(root) {
    if (root.dataset.pdpEnhanced === 'true') return;

    const mediaWrapper = root.querySelector('.product__media-wrapper');
    const infoWrapper = root.querySelector('.product__info-wrapper');
    const productInfo = root.querySelector('[id^="ProductInfo-"]');
    if (!mediaWrapper || !infoWrapper || !productInfo) return;

    const desktopStack = document.createElement('div');
    desktopStack.className = 'product__detail-stack';

    const mobileStack = document.createElement('div');
    mobileStack.className = 'product__mobile-detail-stack';

    mediaWrapper.appendChild(desktopStack);
    infoWrapper.insertAdjacentElement('afterend', mobileStack);

    const children = Array.from(productInfo.children);
    children.forEach((element) => {
      if (element.classList.contains('product__view-details')) {
        element.remove();
        return;
      }

      if (isBundleSupportNode(element)) {
        desktopStack.appendChild(element);
        mobileStack.appendChild(element.cloneNode(true));
        return;
      }

      if (element.classList.contains('product__description') || isDetailAccordion(element) || isSupportNode(element)) {
        desktopStack.appendChild(element);
      }
    });

    const financing = productInfo.querySelector('.product__price-stack .product__financing');
    const productForm = productInfo.querySelector('.product-form');
    if (financing && productForm) {
      financing.dataset.pdpFinancingRelocated = 'true';
      productForm.insertAdjacentElement('afterend', financing);
    }

    buildMobilePanels(root, mobileStack, desktopStack);

    if (!desktopStack.childNodes.length) desktopStack.remove();
    if (!mobileStack.childNodes.length) mobileStack.remove();

    const stickyBar = root.parentElement.querySelector('[data-pdp-sticky-bar]');
    if (stickyBar) {
      syncStickyBar(root, stickyBar);
    }

    setupDesktopStickyState(root);
    setupDesktopThumbnailRail(root);
    setupDesktopGalleryWheel(root);
    syncMobileImageInteractivity(root);
    suppressInjectedPromoPricing(root);
    setupGalleryProgress(root);
    root.dataset.pdpEnhanced = 'true';
    root.parentElement.dataset.pdpEnhanced = 'true';
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(buildDetailLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
